import React from 'react';

import axios from 'axios';
import Cookies from 'js-cookie';
// import CodesitTable from './../common/codesittable.js';
// import PaymentTable from './../common/paymenttable.js';
import {FaUserGraduate }  from "react-icons/fa";

 export default class ParentGroup extends React.Component {
    constructor() {
        super();   

        this.state = {
           paymentList:[],
        };
        this.ask = this.ask.bind(this);
        this.updateForm = this.updateForm.bind(this);
        
        this.componentDidMount = this.componentDidMount.bind(this);
        

    } 

    componentDidMount()
    {
        this.ask("user", "getChildrenCourse", null);
        
    }
    
    ask(section, command, data = null)
    { 
        const params = new URLSearchParams(); 
        //params.append('asc',security.securityKey());
        params.append('section', section);
        params.append('command', command);
        if (data!==null){params.append('data', data);}
        params.append('token', Cookies.get("planetarozwoju"))
        var self = this;
        axios.post(window.location.protocol+ '//' + window.location.hostname,  params).then(function (response) {
            ////console.log("Wnioski",response.data);
            //self.setState({wnioski: response.data});
            
        if (response.data.status==="OK")
        {
            console.log("COMMAND:", command);
            switch(command)
            {
                case 'getChildrenCourse': self.setState({ paymentList:response.data.data, mode:0});break;
                   
                default:break;
                
            }
        }
        else
        {
            console.log(response.data);
            if (response.data.status==="err")
            {
                if (typeof response.data.data.target !== 'undefined')
                {
                    if (response.data.data.target === 'modal'){self.setState({modalState:true, server:response.data.data.message})}
                    else
                    {
                        self.setState({serverResponse: response.data.data.message });
                    }
                }
            }
        }
            // self.setState({pobrano: true});
        }).catch(function (error) {console.log(error);});
    }

    updateForm(data)
    {
        var self = this;
        switch (data.target.dataset.content)
        {
            case "mail": self.setState({mail: data.target.value}); break;
            case "pass": self.setState({pass: data.target.value}); break;
            case 'newpass': self.setState({newpass: data.target.value}); break;
            default:break;
        }
        
    }

    render() {
        var status = ["Nieznany", "Projektowany", "Ankietowany" , "W toku ", "Zamknięty"]
     return (<div className="container">
        <div className="row">
            <div className="col-sm-12">
                <h3><FaUserGraduate /> Grupy do których uczęszczają Twoi podopieczni</h3>
                <div className="prinfo">
                <table className="table">
                <thead>
                    <th>Nazwa grupy</th>
                   
                    <th>status</th>
                    <th>Rozpoczęcie</th>
                    <th>Zakończenie</th>
                </thead>
                <tbody>
                {this.state.paymentList.map((key)=>(<tr key={key.id}>
                    <td>{key.name}</td>
                    
                    <td>{status[parseInt(key.status)]}</td>
                    <td>{key.start}</td>
                    <td>{key.end}</td>
                </tr>))}
                </tbody>
                </table>
                </div>
                {/* <PaymentTable data={this.state.paymentList} readData={this.updateForm} /> */}
                {/* <CodesitTable data={this.state.childrenList} headers={header} /> */}
            </div>
        </div>
     </div>)
    }
 }